import type { JSX } from "react";
import type { ApiResponse } from "@entrilia/shared/api/types.ts";
import type { ExportResponse } from "../../../../../../../api/types/svTypes.ts";
import useExport from "../../../hooks/useExport.ts";
import { useExportStateContext } from "../../builder/common/contexts/ExportStateContext.ts";
import { createBuildExportRequest, createRunExportRequest } from "../../builder/tabular/utilities/exportHelper.ts";
import ExportButton from "./ExportButton.tsx";
import { excelExportOptions } from "./exportOptions.tsx";
import type { ExcelExportSource } from "./exportTypes.ts";

const ExcelReportExport = (source: ExcelExportSource): JSX.Element => {
  const { valueSettings } = useExportStateContext();
  const { exporting, requestExport } = useExport();

  const startExport = (withParameters: boolean): Promise<ApiResponse<ExportResponse>> => {
    if (!source.requestExport) {
      throw new Error("Excel export is not supported");
    }
    if (source.mode === "build") {
      return source.requestExport(
        createBuildExportRequest(source.requestConfig, source.dimensions, withParameters, valueSettings?.value)
      );
    }
    return source.requestExport(
      createRunExportRequest(source.requestConfig, source.dimensions, withParameters, valueSettings?.value)
    );
  };

  return (
    <ExportButton
      exporting={exporting}
      warning={source.warning ?? (source.requestExport ? undefined : "Excel export is not supported")}
      showPrecisionOptions
      options={excelExportOptions.map((option) => ({
        ...option,
        onClick: () => void requestExport(() => startExport(option.withParameters)),
      }))}
    />
  );
};

export default ExcelReportExport;
